var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.token)?_c('span',{staticClass:"highlight"},[_c(_setup.RecommendationsTokenPill,{attrs:{"project":_vm.project,"token":_setup.token,"show-prefix":false,"size":"small"}})],1):_c('span',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }